var _path, _mask, _g, _path2, _path3, _path4, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0177 1L20.0192 9.00154V22.2041C20.0192 23.7508 18.7654 25.0046 17.2187 25.0046H2.81592C1.26922 25.0046 0.0153809 23.7508 0.0153809 22.2041V3.80054C0.0153809 2.25384 1.26922 1 2.81592 1H12.0177Z",
    fill: "#9EACB2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 21,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0177 1L20.0192 9.00154V22.2041C20.0192 23.7508 18.7654 25.0046 17.2187 25.0046H2.81592C1.26922 25.0046 0.0153809 23.7508 0.0153809 22.2041V3.80054C0.0153809 2.25384 1.26922 1 2.81592 1H12.0177Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24762 14.8278C5.24762 14.2086 5.74959 13.7067 6.3688 13.7067C6.98802 13.7067 7.48999 14.2086 7.48999 14.8278C7.48999 15.4471 6.98802 15.949 6.3688 15.949C5.74959 15.949 5.24762 15.4471 5.24762 14.8278Z",
    fill: "#F4F5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9849 14.8278C8.9849 14.2086 9.48687 13.7067 10.1061 13.7067C10.7253 13.7067 11.2273 14.2086 11.2273 14.8278C11.2273 15.4471 10.7253 15.949 10.1061 15.949C9.48687 15.949 8.9849 15.4471 8.9849 14.8278Z",
    fill: "#F4F5F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8434 13.7067C13.2241 13.7067 12.7222 14.2086 12.7222 14.8278C12.7222 15.4471 13.2241 15.949 13.8434 15.949C14.4626 15.949 14.9645 15.4471 14.9645 14.8278C14.9645 14.2086 14.4626 13.7067 13.8434 13.7067Z",
    fill: "#F4F5F8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0193 9.00159H14.9598C13.4131 9.00159 12.0178 7.60629 12.0178 6.0596V1.00005L20.0193 9.00159Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 11.6177,
    y: 0.199846,
    width: 8.80169,
    height: 8.80169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.400077
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.200038
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOther);
export default __webpack_public_path__ + "static/media/file-other.95c663e36d9ca9c690d14cbbc84cb3e5.svg";
export { ForwardRef as ReactComponent };